import { render, staticRenderFns } from "./AdminStudyForm.vue?vue&type=template&id=3c09a0c6&"
import script from "./AdminStudyForm.vue?vue&type=script&lang=js&"
export * from "./AdminStudyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports